import { render, staticRenderFns } from "./RegistrationFreezeRequestFormWarning.vue?vue&type=template&id=66033d57"
import script from "./RegistrationFreezeRequestFormWarning.vue?vue&type=script&lang=js"
export * from "./RegistrationFreezeRequestFormWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports